import { render, staticRenderFns } from "./CardPrinter.vue?vue&type=template&id=1bbd5088"
import script from "./CardPrinter.vue?vue&type=script&lang=ts"
export * from "./CardPrinter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports